import { createFileRoute } from '@tanstack/react-router'

// Level 0 renders from the stack layout (the item list lives there, like every section's list panel);
// the index route itself has nothing to add.
export const Route = createFileRoute('/_app/dev-resources/transitions/one/')({
  component: () => null,
})
